import  {useState} from "react";
import { Button, Card, CardBody, Col, Row, Badge } from "reactstrap";
import { Edit, Trash2 } from "react-feather";
import AddUnavailableDates from "./AddUnavailableDates";


const ProductListcard = ({ products, handleEditClick, handleDeleteClick }) => {
  const [activeDateForm, setActiveDateForm] = useState(null);

  const handleSaveDates = (productId, newRanges) => {
    console.log("Saved unavailable dates for product", productId, newRanges);
    // Add API or state logic here to update the product
    setActiveDateForm(null);
  }; 
  return (
    <Row className="products-admin ratio_asos">
      {products.map((product, index) => (
        <Col xl="3" sm="6" className="mb-4" key={index}>
          <Card className="shadow-sm border-0">
            <div className="products-admin">
              <Badge
                color={product.approval_status === "pending" ? "warning" : "success"}
                className="position-absolute top-0 start-0 m-2 z-1 text-capitalize"
              >
                {product.approval_status}
              </Badge>
              <div className="product-hover position-absolute top-0 end-0 m-2 z-1">
                <Button color="light" className="me-1 p-1" onClick={() => handleEditClick(product.id)}>
                  <Edit size={16} />
                </Button>
                <Button color="light" className="p-1" onClick={() => handleDeleteClick(product.id)}>
                  <Trash2 size={16} />
                </Button>
              </div>
              <div className="product-box d-flex flex-column">
                <div className="img-wrapper position-relative mb-3">
                  <div className="front">
                    <img
                      alt={product.title}
                      className="img-fluid blur-up bg-img lazyloaded w-100"
                      src={product.product_images[0]?.image || "default-image-url"}
                      style={{ objectFit: "cover", height: "200px", borderRadius: "6px" }}
                    />
                  </div>
                </div>

                <div className="product-detail flex-grow-1 d-flex flex-column">
                  <h6 className="mb-1 text-truncate">{product.title}</h6>
                  <div className="mb-2">
                    <span className="fw-bold text-primary">{product.price} €</span>
                  </div>

                  <div className="mb-2">
                    {[...Array(5)].map((_, i) => (
                      <i
                        key={i}
                        className={`fa ${i < product.average_rating ? "fa-star" : "fa-star-o"}`}
                        style={{ color: i < product.average_rating ? "#ffc107" : "#e4e5e9", marginRight: "2px" }}
                      ></i>
                    ))}
                  </div>

                  <div className="text-muted small mb-1">
                    <strong>Stock:</strong> {product.stock ?? "N/A"}
                  </div>
                  <div className="text-muted small mb-3">
                    <strong>Catégorie:</strong> {product.category?.name || "Non définie"}
                  </div>

                  {product.detail && (
                    <p className="text-muted small text-truncate">
                      {product.detail}
                    </p>
                  )}

                  {activeDateForm === product.id ? (
                    <AddUnavailableDates
                      product={product}
                      onSave={(ranges) => handleSaveDates(product.id, ranges)}
                    />
                  ) : (
                    <Button color="info" size="sm" onClick={() => setActiveDateForm(product.id)}>
                      Ajouter une date
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default ProductListcard;
